import React, { useCallback, useMemo } from 'react'
import { Like } from '@groovehq/internal-design-system/lib/assets/icons/facebook-messenger'
import { getMatrixClient } from 'ducks/chat/utils/client'
import { isFacebookMessengerRoom } from 'ducks/chat/utils/messenger'
import { useChatComposer } from 'ducks/chat/hooks/composer'
import { useMatrixRoomById } from 'ducks/chat/hooks/rooms'
import { getStickerContentById } from 'ducks/chat/utils/rooms'

import { styles } from './styles'

export default function FacebookLikeControl({ roomId }) {
  const { room, prepareMessage, accountChatRoomId } = useChatComposer(roomId)
  const accountChatRoom = useMatrixRoomById(accountChatRoomId)

  const isFbRoom = useMemo(
    () => {
      if (!room) return false
      return isFacebookMessengerRoom(room)
    },
    [room]
  )

  const handleOnClick = useCallback(
    async () => {
      const client = getMatrixClient()

      if (!room) return
      if (!accountChatRoom) return
      if (!client) return

      const stickerContent = getStickerContentById(accountChatRoom, 'fb_like')

      const content = await prepareMessage({
        roomId,
        room,
        content: stickerContent,
        editorModel: { parts: [] },
        composer: null,
      })

      client.sendMessage(roomId, content)
    },
    [roomId, prepareMessage, room, accountChatRoom]
  )

  if (!isFbRoom) return null

  return (
    <div
      css={styles.svgButton}
      className="composer-button"
      onClick={handleOnClick}
    >
      <div>
        <div>
          <Like />
        </div>
      </div>
    </div>
  )
}
